import { render, staticRenderFns } from "./roi-data-item.vue?vue&type=template&id=3468ed4d&scoped=true&"
import script from "./roi-data-item.vue?vue&type=script&lang=ts&"
export * from "./roi-data-item.vue?vue&type=script&lang=ts&"
import style0 from "./roi-data-item.vue?vue&type=style&index=0&id=3468ed4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3468ed4d",
  null
  
)

export default component.exports